export default __webpack_public_path__ + "static/media/108t.2e3352e8.jpg";